export default function CVariablesConstants() {
  return <h2>C Variables Constants</h2>;
}
